// 👥 Employés E4 — enveloppe de section : en-tête, bouton Modifier / Enregistrer / Annuler, indicateur « non enregistré ».
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Pencil, Save, X } from 'lucide-react';
import { useEditionFiche } from '@/hooks/useEditionSection';

export function SectionFiche({ cle, titre, icone: Icone, peutModifier, edition, children, actions = null }) {
  const { sale } = useEditionFiche();
  return (
    <Card data-testid={`section-${cle}`} className={edition?.enEdition ? 'border-blue-300 ring-1 ring-blue-200' : ''}>
      <CardHeader className="pb-2 flex flex-row items-center justify-between space-y-0">
        <CardTitle className="text-base flex items-center gap-2">
          {Icone && <Icone className="w-4 h-4 text-slate-500" />}{titre}
          {edition?.enEdition && sale && <Badge className="bg-amber-100 text-amber-800 text-[10px]" data-testid={`section-${cle}-non-enregistre`}>Modifications non enregistrées</Badge>}
        </CardTitle>
        <div className="flex items-center gap-2">
          {actions}
          {peutModifier && edition && !edition.enEdition && (
            <Button size="sm" variant="outline" onClick={edition.modifier} title="Modifier" data-testid={`section-${cle}-modifier`}>
              <Pencil className="w-3.5 h-3.5 mr-1" /> Modifier
            </Button>
          )}
          {edition?.enEdition && (
            <>
              <Button size="sm" variant="outline" onClick={edition.annuler} disabled={edition.saving} data-testid={`section-${cle}-annuler`}><X className="w-3.5 h-3.5 mr-1" /> Annuler</Button>
              <Button size="sm" onClick={edition.enregistrer} disabled={edition.saving} data-testid={`section-${cle}-enregistrer`}><Save className="w-3.5 h-3.5 mr-1" /> Enregistrer</Button>
            </>
          )}
        </div>
      </CardHeader>
      <CardContent className="pt-2">{children}</CardContent>
    </Card>
  );
}

/** Champ lecture/édition unifié. */
export function Champ({ label, valeur, enEdition, children, erreur, testid, vide = 'Non renseigné' }) {
  return (
    <div data-testid={testid}>
      <p className="text-xs text-slate-500">{label}</p>
      {enEdition ? children : <p className="text-sm text-slate-800 mt-0.5">{valeur === null || valeur === undefined || valeur === '' ? <span className="text-slate-400">{vide}</span> : String(valeur)}</p>}
      {erreur && <p className="text-xs text-red-600 mt-1" data-testid={`${testid}-erreur`}>{erreur}</p>}
    </div>
  );
}
